import { render, staticRenderFns } from "./family-apply-detail.vue?vue&type=template&id=76bb9d7e&scoped=true"
import script from "./family-apply-detail.vue?vue&type=script&lang=js"
export * from "./family-apply-detail.vue?vue&type=script&lang=js"
import style0 from "./family-apply-detail.vue?vue&type=style&index=0&id=76bb9d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2f37ed56e32c39bf37bd07aa5cbb5c73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bb9d7e",
  null
  
)

export default component.exports